import { Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MainCard from './MainCard';
import { CompanyIcon } from 'assets/svgs/index';
import { useTheme } from '@mui/material/styles';

const NotFound = ({ message, buttonTitle, path, isCompany = false }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <MainCard
      content={false}
      sx={{
        // maxWidth: '728px',
        padding: 2,
        height: { xs: '300px', sm: '500px' },
        display: 'flex',
        margin: 'auto'
      }}
    >
      <Stack
        sx={{ width: '400px', margin: 'auto' }}
        spacing={3}
        alignItems={'center'}
      >
        {isCompany && (
          <CompanyIcon
            height={'80px'}
            width={'80px'}
            style={{ opacity: 0.4 }}
            stroke={theme.palette.secondary.main}
          />
        )}
        <Typography
          variant={'h1'}
          color={'secondary.light'}
        >
          {message}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ width: '200px', margin: 'auto' }}
          onClick={() => navigate(path)}
        >
          {buttonTitle}
        </Button>
      </Stack>
    </MainCard>
  );
};

export default NotFound;
